import { loginCode, login, oauthTokenLogin } from '@/api/login';
import { getInfo, getDictionary } from '@/api/user';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';

const state = {
    token: getToken(),
    userInfo: {},
    collapseMenu: false,
    isLogin: false, // 登录状态 true 已登录，false 未登录
    dictionary: [],
    chooseHospital: 'doctor' || sessionStorage.getItem('chooseHospitalManage')
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo;
    },
    SET_COLLAPSEMENU: (state, collapseMenu) => {
        state.collapseMenu = collapseMenu;
    },
    SET_HOSPITAL: (state, data) => {
        state.chooseHospital = data;
    },
    SET_DICTIONARY: (state, data) => {
        state.dictionary = data;
    },
    SET_LOGIN_STATUS: (state, data) => {
        state.isLogin = data;
    }
};

const actions = {
    ChangeCollapseMenu({ commit }, collapseMenu) {
        commit('SET_COLLAPSEMENU', collapseMenu);
    },
    // 切换医院
    ChooseHospital({ commit }, name) {
        sessionStorage.setItem('chooseHospitalManage', name);
        commit('SET_HOSPITAL', name);
    },
    // user login
    login({ commit }, userInfo) {
        const { userName, password, verificationCode, grant_type } = userInfo;
        return new Promise((resolve, reject) => {
            oauthTokenLogin({
                grant_type: grant_type,
                username: userName,
                password: password,
                verificationCode: verificationCode
            })
                .then(response => {
                    if (response && response.access_token) {
                        let token = response.access_token;
                        commit('SET_TOKEN', token);
                        setToken(token);
                        resolve();
                    } else {
                        resolve('error');
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // 手机验证码登录
    message({ commit }, userInfo) {
        const { username, grant_type, password } = userInfo;
        return new Promise((resolve, reject) => {
            oauthTokenLogin({
                password: password,
                grant_type: grant_type,
                username: username
            })
                .then(res => {
                    if (res && res.access_token) {
                        let token = res.access_token;
                        commit('SET_TOKEN', token);
                        setToken(token);
                        resolve();
                    } else {
                        resolve('error');
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getInfo()
                .then(response => {
                    const results = response.results;
                    if (!results.iuid) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject('Verification failed, please Login again.');
                    }
                    // 判断登录用户是否有roles，有则跳转
                    if (results.roles && results.roles.length > 0) {
                        // 设置登录状态 true 已登录，false 未登录
                        commit('SET_LOGIN_STATUS', true);
                        commit('SET_USER_INFO', results);
                        resolve(results);
                    } else {
                        resolve('noRoles');
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 获取字典项
    GetDictionary({ commit, state }) {
        return new Promise((resolve, reject) => {
            getDictionary()
                .then(res => {
                    if (res.results) {
                        commit('SET_DICTIONARY', res.results);
                        resolve(res.results);
                    } else {
                        resolve('error');
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            commit('SET_USER_INFO', {});
            commit('SET_DICTIONARY', {});
            commit('SET_LOGIN_STATUS', false);
            removeToken();
            resolve();
        });
    },

    // user logout
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            removeToken();
            commit('SET_TOKEN', '');
            commit('SET_USER_INFO', {});
            commit('SET_DICTIONARY', {});
            commit('SET_LOGIN_STATUS', false);
            resetRouter();
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
